export enum CampaignStatusEnum {
	ACTIVE=25,
	SCHEDULE=26,
	COMPLETED = 27,  
	DRAFT = 24,
	DELETE = 37,
	STOP = 48,
	RUNNINGTEST = 61,
}